import _axios from "axios";
import { toast } from "react-toastify";
import store from "../store/store";
import { refreshToken } from "../api";
import { saveToken } from "../store/slice/userSlice";

const googleClientId = process.env.REACT_APP_GOOGLE_APP_ID;

export const GOOGLE_AUTH = `https://accounts.google.com/o/oauth2/auth?client_id=${googleClientId}&redirect_uri=${window.location.origin}/auth/google-callback&scope=openid+profile+email+https://www.googleapis.com/auth/user.phonenumbers.read&response_type=code`;

export const axios = (() => {
  const axios = _axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return axios;
})();

const setToken = (token) => {
  store.dispatch(saveToken(token));
};

const clearToken = () => {
  store.dispatch(saveToken(null));
  axios.defaults.headers.common.Authorization = null;
};

const select = (state) => state.userReducer.token;
const urlDisable = ["/auth/refresh"];

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = decodeURIComponent(
    atob(base64Url)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(base64);
}

// const pollingToken = new Promise((resolve, reject) => {
//   const newToken = select(store.getState());
//   if (newToken === tokenData) {
//     setTimeout(pollingToken, 500);
//   } else {
//     resolve(newToken)
//   }
// });

axios.interceptors.request.use(
  async function (config) {
    const tokenData = select(store.getState());
    if (!urlDisable.includes(config.url) && tokenData) {
      const dateNow = new Date();
      const parsedToken = parseJwt(tokenData);
      const expToken = parsedToken.exp * 1000;
      const isExp = dateNow.getTime() > expToken;

      if (isExp) {
        // try {
        const res = await refreshToken(tokenData)
          .then((res) => {
            config.headers.Authorization = `Bearer ${res.data.access_token}`;
            setToken(res.data.access_token);
          })
          .catch((err) => {
            if (err.response?.data.title === "Forbidden") {
              clearToken();
              window.location.reload();
            } else {
              console.log(err);
            }
          });
      } else {
        config.headers.Authorization = `Bearer ${tokenData}`;
      }
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    if(response.config.url === "/auth/google-login") {
      return response;
    } else {
      return response.data;
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const setAuthorizationHeader = (token = null) => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const convertDate = (date, delimiter = ".", monthIsText = false) => {
  const newDate = new Date(date);
  const yyyy = newDate.getFullYear();
  let mm = monthIsText ? monthNames[newDate.getMonth()] : newDate.getMonth() + 1;
  let dd = newDate.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedDate = dd + delimiter + mm + delimiter + yyyy;

  return formattedDate;
};

export const getLabelByValue = (options = {}, listId = {}) => {
  const labels = {};

  for (let key in listId) {
    if (options[key]) {
      const optionsKey = key === "translationType" ? options[key][listId.type] : options[key];
      labels[key] = optionsKey?.find((option) => option.value === listId[key])?.label;
    }
  }

  return labels;
};

export const showNotification = (message = "not Message", type = "error") => {
  toast[type](message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export const getTimeFromMins = (mins) => {
  const hours = Math.trunc(mins / 60);
  const minutes = mins % 60;
  return hours + ":" + (minutes ? minutes : "00");
};

export const convertPrice = (price) => Number(price) / 100;

const bookingStatus = {
  approved: {
    value: "going",
    label: "Approved",
  },
  cancelled: {
    value: "canceled",
    label: "Cancaled",
  },
  removed_by_admin: {
    value: "canceled",
    label: "Canceled",
  },
  completed: {
    value: "completed",
    label: "Completed",
  },
};

export const orderNormalaise = (orders = []) => {
  const formatedOrders = orders.map((order) => {
    const dataFrom = new Date(order.from)
    const dateStartUnix = order.from && dataFrom.getTime() / 1000; // iso to unix
    const createdAt = convertDate(order.createdAt, " ", true);
    const fromDate = convertDate(order.from, " ", true);
    const startTime = dataFrom.getHours() + ":" + dataFrom.getMinutes();
    const duration = order.services?.[0]?.service.duration;
    const duratInHours = duration && getTimeFromMins(duration);

    return {
      id: order.id,
      from: fromDate,
      startTime: startTime,
      durationSession: duratInHours,
      createdAt: createdAt,
      dateStartUnix: dateStartUnix,
      master: order.master,
      payed: order.payed,
      paymentType: order.paymentType,
      price: convertPrice(order.price),
      services: order.services,
      status: bookingStatus[order.status],
      studio: order.studio,
    };
  });

  return formatedOrders;
};
